export default "__VITE_ASSET__B02aEfgE__"